import {useState, useEffect, useRef } from 'react'
import { useMapsLibrary} from '@vis.gl/react-google-maps'
import { config, searchRestrictions } from '../../config';


interface PlaceAutocompleteProps {
  onPlaceSelect: (place: google.maps.places.PlaceResult | null) => void;
  initialBounds: google.maps.LatLngBounds | undefined
  clearFlag: boolean
  setClearFlag: (flag:boolean) => void
}

const PlaceAutocomplete = ({ onPlaceSelect, initialBounds, clearFlag, setClearFlag }: PlaceAutocompleteProps) => {
  const [placeAutocomplete, setPlaceAutocomplete] =
    useState<google.maps.places.Autocomplete | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const places = useMapsLibrary('places');

  useEffect(() => {
    if (!clearFlag) return
    placeAutocomplete?.set('place', null)
    if (inputRef && inputRef.current) inputRef.current.value = ''
    setClearFlag(false)

  }, [clearFlag, placeAutocomplete, setClearFlag])

  useEffect(() => {
    if (!places || !inputRef.current || !initialBounds) return;

    searchRestrictions.bounds = initialBounds

    setPlaceAutocomplete(new places.Autocomplete(inputRef.current, searchRestrictions));
  }, [places, initialBounds]);

  useEffect(() => {
    if (!placeAutocomplete) return;

    placeAutocomplete.addListener('place_changed', () => {
      console.log(placeAutocomplete.getPlace())
      onPlaceSelect(placeAutocomplete.getPlace());
    });
  }, [onPlaceSelect, placeAutocomplete]);

  return (
    <>
      <label className='nsw-form__label' htmlFor={`${config.namespace}-location-search`}>Search by address, suburb or postcode</label>
      <input ref={inputRef} className='nsw-form__input' type='text' id={`${config.namespace}-location-search`} name={`${config.namespace}-location-search`} aria-describedby={`${config.namespace}-location-search-help`} />
    </>
  );
};

export default PlaceAutocomplete
